const BEARER = 'Bearer';
const HEADER_AUTHORIZATION = 'Authorization';
const TOKEN_HEADER_KEY = '_token';
const TOKEN_STORAGE_KEY = 'pz_token';
const INVALID_TOKEN_VALUES = new Set(['undefined', 'null', '']);

const isPersistableToken = (token) =>
  typeof token === 'string' && !INVALID_TOKEN_VALUES.has(token.trim());

export const clear = () => {
  window.sessionStorage.removeItem(TOKEN_STORAGE_KEY);
};

export const get = () => {
  return window.sessionStorage.getItem(TOKEN_STORAGE_KEY);
};

export const set = (headers = {}) => {
  const token = headers[TOKEN_HEADER_KEY];

  if (!isPersistableToken(token)) {
    clear();
    return;
  }

  window.sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
};

export const getHeaderAuthorization = (requestToken) => {
  const token = requestToken || get();

  return isPersistableToken(token) ? `${BEARER} ${token}` : null;
};

export const getSDKTokenHeader = () => ({
  headers: { [HEADER_AUTHORIZATION]: getHeaderAuthorization() },
});
